import React, { useReducer, createContext, useContext } from "react";
import { GlobalConstants } from "./constants/GlobalConstants";

export const Reducer = (state: any, { type, payload }: any) => {
  switch (type) {
    case GlobalConstants.BCStoreReducerCases.SET_USER:
      return {
        ...state,
        user: payload,
      };
    default:
      return state;
  }
};

const initialState: any = {
  user: null
};

const BCGlobalMetadataStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState);
  return (
    <Context.Provider value={[state, dispatch]}>{children}</Context.Provider>
  );
};

export const Context = createContext(initialState);
export const useBCGlobalMetadataReducer = () => useContext(Context);
export default BCGlobalMetadataStore;